<template>
	<subir-cunas></subir-cunas>
</template>

<script>
import Main from './components/Main.vue'

export default {
	components: {
		'subir-cunas': Main
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/subir-cunas/vue/App.vue